import _ from 'lodash';

const LossCauseDescToCodeMap = Object.freeze({
    InsVehRearThrdPty: '1',
    InsVehRev: '2',
    InsVehImmProp: '3',
    InsVehEmMinRd: '4',
    InsVehChLns: '5',
    HdColl: '6',
    MtplShnt: '7',
    CollAnml: '8',
    CollPedstrn: '9',
    LdUnld: '10',
    Weather: '11',
    HitByThrdPty: '12',
    TPRearInsVeh: '13',
    TPRevInsVeh: '14',
    ThrdPtyEmMinRd: '15',
    ThrdPtyVehChLns: '16',
    MalDmg: '17',
    Fire: '18',
    TheftOfVeh: '19',
    TheftFromVeh: '20',
    WindscrOnly: '21',
    DebrOnRd: '22',
    InsOpenDoor: '23',
    ThrdPtyOpenDoor: '24',
    MisFuelling: '25',
    ItmsFllInsVeh: '26',
    ItmsFllThrdPtyVeh: '27',
    Other: '98',
    NotYetDetermined: '99',
    ThftLossOfKeys: '28'
});

const CollisionCodes = [
    LossCauseDescToCodeMap.InsVehRearThrdPty,
    LossCauseDescToCodeMap.InsVehRev,
    LossCauseDescToCodeMap.InsVehImmProp,
    LossCauseDescToCodeMap.InsVehEmMinRd,
    LossCauseDescToCodeMap.InsVehChLns,
    LossCauseDescToCodeMap.HdColl,
    LossCauseDescToCodeMap.MtplShnt,
    LossCauseDescToCodeMap.CollAnml,
    LossCauseDescToCodeMap.CollPedstrn,
    LossCauseDescToCodeMap.HitByThrdPty,
    LossCauseDescToCodeMap.TPRearInsVeh,
    LossCauseDescToCodeMap.TPRevInsVeh,
    LossCauseDescToCodeMap.ThrdPtyEmMinRd,
    LossCauseDescToCodeMap.ThrdPtyVehChLns,
    LossCauseDescToCodeMap.InsOpenDoor,
    LossCauseDescToCodeMap.ThrdPtyOpenDoor
];

const TheftCodes = [
    LossCauseDescToCodeMap.TheftOfVeh,
    LossCauseDescToCodeMap.TheftFromVeh,
    LossCauseDescToCodeMap.ThftLossOfKeys
];

const GlassCodes = [
    LossCauseDescToCodeMap.WindscrOnly
];

export default {
    LossCauseDescToCodeMap: LossCauseDescToCodeMap,

    getCollisionCodes: () => {
        return CollisionCodes;
    },

    getTheftCodes: () => {
        return TheftCodes;
    },

    getGlassCodes: () => {
        return GlassCodes;
    },

    getOtherCodes: () => {
        const clasifiedCodes = CollisionCodes.concat(TheftCodes, GlassCodes);
        return _.filter(Object.values(LossCauseDescToCodeMap), (code) => {
            return _.indexOf(clasifiedCodes, code) === -1;
        });
    },

    getLossCauseCategory: (code) => {
        if (CollisionCodes.includes(code)) {
            return 'collision';
        } else if (TheftCodes.includes(code)) {
            return 'theft';
        } else  {
            return 'other';
        }
    }
};